import authSvc from "../../services/api/auth";
import { useAtom } from "jotai";
import { csrfToken } from "../../store/atoms";
import { useEffect, useState } from "react";
import LoadingFullscreen from "../../components/loading/LoadingFullscreen";
import { getCookies, setCookiesCsrfToken } from "../../utils/configuration";
import { notify } from "../../common/notificationService";
import { CSRF_TOKEN_KEY } from "../../config/common";

export const GetCsrfToken = () => {

    const [loading, setLoading] = useState(false);
    const [csrfTokenFromState, setCsrfToken] = useAtom(csrfToken);

    const getCookiesCsrfToken = async () => {
        const token = getCookies(CSRF_TOKEN_KEY);
        if (token) {
            setCsrfToken(token);
        } else {
            setLoading(true);
            try {
                const res = await authSvc.getCsrfToken();
                if (res) {
                    setCsrfToken(res.token);
                    setCookiesCsrfToken(res.token);
                }
            } catch (error) {
                console.error(error);
                notify("Lỗi", "Xảy ra lỗi! vui lòng liên hệ Admin", "danger");
            } finally {
                setLoading(false);
            }
        }
    }

    useEffect(() => {
        if (!csrfTokenFromState) {
            getCookiesCsrfToken();
        }
    }, [csrfTokenFromState]);

    return (
        <div>
            {loading ? <LoadingFullscreen /> : null}
        </div>
    );
}

export default GetCsrfToken;